import { RequirementEvaluation } from '../interfaces/Organization';
import { MEvaluationEvidence } from './evaluation-evidence.model';
import { MResultType } from './result-type.model';

export class MRequirementEvaluation{
    public id:number;
    public typeResultId: number;
    public resultType: MResultType = null;
    public description1: string;
    public description2: string;
    public createdAt: string;
    public updatedAt: string;
    public evidence: MEvaluationEvidence[] = [];

    constructor(eva: RequirementEvaluation){
        this.id = eva.id;
        this.typeResultId = eva.tipo_resultado_id;
        this.description1 = eva.descripcion1;
        this.description2 = eva.descripcion2;
        this.createdAt = eva.created_at;
        this.updatedAt = eva.updated_at;
        if (eva.tipo_resultado) {
            this.resultType = new MResultType(eva.tipo_resultado)            
        }
        eva.evidencias_evaluaciones.forEach(ev => {
            this.evidence.push(new MEvaluationEvidence(ev))
        });
    }
}